module.exports = __webpack_public_path__ + "img/button_home.07e878c7.svg";